import { render, staticRenderFns } from "./ResendChannelDialog.vue?vue&type=template&id=5d2a3695&"
import script from "./ResendChannelDialog.vue?vue&type=script&lang=js&"
export * from "./ResendChannelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports